import PropTypes from 'prop-types'
import OptionShapePropType from './OptionShapePropType'

const OptionGroupShapePropType = PropTypes.shape({
  label: PropTypes.string,
  statusColor: PropTypes.string,
  options: PropTypes.arrayOf(OptionShapePropType)
})

export default OptionGroupShapePropType
